import type React from 'react'

import API from '@/api'
import { useCountdown } from './hooks'
import css from './styles.module.css'
import { formatTime } from './utils'

type Props = {
  utcTime: string
}

export const ResendCode: React.FC<Props> = ({ utcTime }) => {
  const { timeLeft, isActive, setTargetTime } = useCountdown(utcTime)

  const handleClick = () => {
    if (isActive) {
      API.Auth.resendCode()
        .then((response) => {
          setTargetTime(response.emailVerificationCodeExpiresAt)
        })
        .catch((error) => {
          console.error('Problem with resending verification code', error)
        })
    }
  }

  if (isActive) {
    return (
      <div className={css.resend_code_container}>
        <span className={css.active} onClick={handleClick}>
          Resend code
        </span>
      </div>
    )
  }

  return (
    <div className={css.resend_code_container}>
      You can resend the verification code in {formatTime(timeLeft)}
    </div>
  )
}
